import { FC, memo } from 'react'

import { PopularFiltersSectionTransport } from '../../../transports/region-landing-page-transport'
import ExternalLink from '../../common/external-link'
import { useTranslation } from '../../../hooks/locale'
import { Container, IconBox, MenuContainer, MenuWrapper, Section, SubtitleSpan, TitleSpan } from './styles'
import FilterIcon from './filter-icon'
import { Title, TitleContainer } from '../common/styles'

interface PopularObjectProps {
    popularFiltersSection: PopularFiltersSectionTransport
}

const PopularObjectSection: FC<PopularObjectProps> = ({ popularFiltersSection }) => {
    const { t } = useTranslation()
    const { heading, filters } = popularFiltersSection
    return (
        <Section id="popular-objects">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <Container>
                {filters.map(filter => (
                    <MenuWrapper key={filter.resultListUrl}>
                        <ExternalLink
                            title={filter.title}
                            as={MenuContainer}
                            href={`${filter.resultListUrl}`}
                            noCrawl={filter.noCrawl}
                        >
                            <IconBox>
                                <FilterIcon filterKey={filter.title} aria-label={`${filter.title}-icon`} />
                            </IconBox>
                            <TitleSpan>{filter.title}</TitleSpan>
                            <SubtitleSpan>{`${filter.count} ${
                                filter.count === 1 ? t('accommodation') : t('accommodations')
                            }`}</SubtitleSpan>
                        </ExternalLink>
                    </MenuWrapper>
                ))}
            </Container>
        </Section>
    )
}

export default memo(PopularObjectSection)
